export const Beacon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#55565C"
        fillRule="evenodd"
        d="M1.21 6.364a9.472 9.472 0 0 1 2.063-3.082l.706.708A8.472 8.472 0 0 0 1.489 10c0 2.347.951 4.472 2.49 6.01l-.707.708A9.472 9.472 0 0 1 .49 10a9.472 9.472 0 0 1 .72-3.636Zm3.025 1.253a6.21 6.21 0 0 1 1.351-2.02l.707.707A5.21 5.21 0 0 0 4.763 10c0 1.443.584 2.75 1.53 3.697l-.707.707A6.212 6.212 0 0 1 3.762 10a6.21 6.21 0 0 1 .473-2.383Zm10.158-2.02A6.21 6.21 0 0 1 16.217 10a6.211 6.211 0 0 1-1.824 4.404l-.707-.708a5.211 5.211 0 0 0 1.53-3.695V10a5.21 5.21 0 0 0-1.53-3.696l.707-.708ZM7.9 7.91a2.955 2.955 0 1 1 4.179 4.178A2.955 2.955 0 0 1 7.9 7.911Zm2.09.135a1.955 1.955 0 1 0 0 3.909 1.955 1.955 0 0 0 0-3.91Z"
        clipRule="evenodd"
      />
      <path
        fill="#55565C"
        fillRule="evenodd"
        d="M18.79 6.364a9.472 9.472 0 0 0-2.063-3.082l-.706.708a8.473 8.473 0 0 1 2.49 6.01c0 2.346-.951 4.471-2.49 6.01l.707.707A9.472 9.472 0 0 0 19.51 10a9.472 9.472 0 0 0-.72-3.636Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
